export default "__VITE_ASSET__BPpOcdUz__"